<template>
  <div class="main-wrapper" >

    <div class="main-scroll">
      <Navs :flag="flag" />
      <Homes />
      <Foots class="foots" />
    </div>
    <bottom-backtop></bottom-backtop>
  </div>
</template>

<script>
import Navs from '../../common/navs'
import Foots from '../../common/foots'
import Homes from './recruitList'
import BottomBacktop from '../../common/BottomBacktop';


export default {
  components: {
    Navs,
    Foots,
    Homes,
    BottomBacktop
  },
  data() {
    return {
      flag: false
    }
  }
}
</script>

<style lang="scss" scoped></style>
